// extracted by mini-css-extract-plugin
export default {"presMain":"prescription_presMain__QKLJO","heading":"prescription_heading__0aCKq","patientDetails":"prescription_patientDetails__gzHan","form":"prescription_form__3Nzqt"};